import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchOrderHubOrder } from '@/api/order-hub';
import { ordersHubKeys } from './useOrdersHubList';

/** Single order detail — unwraps the `{ data }` envelope so consumers get the
 *  bare `OrderHubOrder`. Shared query options so the route loader can warm the
 *  cache before the component renders. */
export function orderHubDetailQueryOptions(id: string) {
  return queryOptions({
    queryKey: ordersHubKeys.detail(id),
    queryFn: () => fetchOrderHubOrder(id).then(res => res.data),
    staleTime: 30_000,
  });
}

export function useOrderHubOrderDetail(id: string) {
  return useQuery(orderHubDetailQueryOptions(id));
}
